import Route from '@ember/routing/route'

export default class MxRoute extends Route {
  queryParams = {
    studentGrade: {
      refreshModel: true,
      replace: true,
    },
    lessonLevelDomainIds: {
      refreshModel: true,
      replace: true,
    },
  }
}
